export function sessionBasePath(activityType) {
  return activityType === 'StepDance' ? '/step-dance' : '/openplays';
}

// Sessions created before activityType was introduced are pickleball Open Play.
export function matchesSessionActivity(session, activityType) {
  return (session.activityType || 'OpenPlay') === activityType;
}
